export default theme => ({
    
    div: {
        backgroundColor: 'white',
        border: '1px solid #333',
        width: '75vw',
        [theme.breakpoints.up('xs')]: {
            width: '75vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },
    tdTrend:{
        textAlign:"center"
      },
      td:{
        padding:"0px 0px 0px 0px",
        borderTop: "0px solid #e4dede",
        borderBottom: "0px ",
        width:"2% !importante",
      },
    
  });
  
  